
import { format } from "date-fns";
import { pt } from "date-fns/locale";

export const formatDate = (dateString: string | null) => {
  if (!dateString) return "N/A";
  return format(new Date(dateString), "dd/MM/yyyy HH:mm", { locale: pt });
};

export const formatDateTime = (dateString: string | null) => {
  return formatDate(dateString);
};
